function TitleWithIcon({
  icon,
  title,
  titleDir,
}: {
  icon: string;
  title?: string;
  titleDir?: "ltr" | "rtl";
}) {
  return (
    <div
      className={`flex items-center gap-2 rounded-lg border border-systemBg bg-InputFieldColor p-3 font-[500] ${!title ? "hidden" : ""}`}
    >
      <img alt="contact" className="w-5" src={icon} />
      <div dir={titleDir}>{title}</div>
    </div>
  );
}

export default TitleWithIcon;
